import { render, staticRenderFns } from "./SurveyQuestionGraph.vue?vue&type=template&id=24f0527e&"
import script from "./SurveyQuestionGraph.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports